import {ConditionSelect} from 'sma.admin/components/conditionselect';
import DatePicker from 'sma.admin/components/datepicker';
import DropSelector from 'sma.admin/components/dropdowns/dropselector';

let predicateSelectTemplate = require('sma.admin/components/partials/filters/predicate_select.mustache');
let filterCompareTemplate = require('sma.admin/components/partials/filters/filter_value.mustache');

class ConditionSelectFilters extends ConditionSelect {
	/**
	 * @override
	 */
	searchFilters(e) {
		this.throttledSearch();

		// Enable the apply filter button
		this.grid.$el.find('.sma-js-apply-filter-button').addClass('disabled');

		this.grid.$el.find('.sma-js-predicates-wrap').empty();
		this.grid.$el.find('.sma-js-value-wrap').empty();
	}

	/**
	 * @override
	 */
	selectedCondition(e) {
		this.conditionElement = $(e.currentTarget).find('.sma-js-condition-link');
		var conditionKey = this.conditionElement.data('key')

		// Update the search bar with the selected value and the associated key
		var searchBar = this.grid.$el.find('.sma-js-search');
		searchBar.val(this.conditionElement.text().trim());
		searchBar.data('key', conditionKey);

		this.updatePredicate();
		this.updateValue();
	}

	updatePredicate() {
		this.grid.$el.find('.sma-js-predicates-wrap').empty();

		this.predicateType = this.conditionElement.data('predicates');

		this.predicates = this.data.predicate_map[this.predicateType];
		let $predicateSelectEl = $(predicateSelectTemplate({
			'predicates': this.predicates,
		}));

		this.predicateSelect = new DropSelector({
			dropdownToggle: true,
			buttonSize: 'btn-sm',
			$selectEl: $predicateSelectEl,
		});

		let $predicateSelectContainer = this.grid.$el.find('.sma-js-predicates-wrap');

		$predicateSelectContainer.append($predicateSelectEl);
		$predicateSelectContainer.append(this.predicateSelect.$el);

		if($predicateSelectContainer.is(":hidden")) {
			$predicateSelectContainer.toggle();
		}

		$predicateSelectEl.on('change', () => {
			this.updateValue();
		});

	}

	updateValue() {
		this.grid.$el.find('.sma-js-value-wrap').empty();

		let choices = this.conditionElement.data('choices');
		let hasChoices = this.predicateType === 'select';
		let isNumberInput = this.predicateType === 'number';
		const predicateValue = $('.sma-js-predicates-select').val();

		let isNested = false;
		let newChoices = [];
		for (let i=0; i < choices.length; i++)
			if (Array.isArray(choices[i][1])) {
				isNested = true;
				break;
			}

		_.each(choices, function(choice, c) {
			if (isNested) {
				let items = [];
				_.each(choice[1], function(item, i) {
					items.push({'label': item[1], 'value': item[0]});
				});
				newChoices.push({group: choice[0], options: items});
			} else {
				newChoices.push({'label': choice[1], 'value': choice[0]});
			}
		});

		let valueIsMultiselect = _.findWhere(this.predicates, {value: this.predicateSelect.val()}).multiselect;

		// mustache template of the select
		let $filterCompareValue = $(filterCompareTemplate({
			'hasChoices': hasChoices,
			'choices': newChoices,
			'multiselect': valueIsMultiselect,
			'isNested': isNested,
			'isNumberInput': isNumberInput,
		}));

		// Throw the select into the container
		let $filterCompareValueContainer = this.grid.$el.find('.sma-js-value-wrap');
		$filterCompareValueContainer.append($filterCompareValue);

		// use the DatePicker if it's a date type
		if (this.predicateType === 'date') {
			new DatePicker($filterCompareValue);
		}

		// if it's a boolean type we don't need a value
		if (this.predicateType === 'boolean') {
			$filterCompareValue.hide();
			$('.sma-js-apply-filter-button').removeClass('disabled');
		}

		// if value is a selectbox, let's show our nice dropselector
		if ($filterCompareValue.filter('select').length) {
			var filterCompareValueSelector = new DropSelector({
				dropdownToggle: true,
				buttonSize: 'btn-sm',
				$selectEl: $filterCompareValue,
				multiselect: valueIsMultiselect
			});

			$filterCompareValueContainer.append(filterCompareValueSelector);
		}

		// If the container is hidden lets make it visible
		if($filterCompareValueContainer.is(":hidden")) {
			$filterCompareValueContainer.toggle();
		}

		//hide the value box if the predicate is "has no value"
		if (predicateValue === "hasnovalue" || this.predicateType === 'boolean') {
			$filterCompareValueContainer.hide();
			$('.sma-js-apply-filter-button').removeClass('disabled');
		} else if (hasChoices) {
			$('.sma-js-apply-filter-button').removeClass('disabled');
		} else {
			$filterCompareValue.on("input change", this.handleIfCanApplyFilter);
			$('.sma-js-apply-filter-button').addClass('disabled');
		}
	}

	handleIfCanApplyFilter(e) {
		const target = e.currentTarget;

		if (target.value === '') {
			$('.sma-js-apply-filter-button').addClass('disabled');
		} else {
			$('.sma-js-apply-filter-button').removeClass('disabled');
		}
	}
}

module.exports = {
	ConditionSelectFilters: ConditionSelectFilters,
}
